import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-md mb-4" }
const _hoisted_2 = { class: "flex justify-between items-center text-start text-sm w-full pe-5 truncate ..." }
const _hoisted_3 = { class: "flex justify-start items-center" }
const _hoisted_4 = { class: "text-darkText font-bold" }
const _hoisted_5 = { class: "ms-1 text-xs" }
const _hoisted_6 = { class: "ms-1 text-xs" }
const _hoisted_7 = {
  key: 0,
  class: "px-665 pt-5 pb-665 border-t border-line"
}
const _hoisted_8 = { class: "ms-2.5 ps-2.5" }
const _hoisted_9 = { class: "flex justify-start border-s-2 border-dashed" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center order-pointer w-5 h-5 rounded-full bg-trackPointerLight relative -start-665" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "w-2.5 h-2.5 rounded-full bg-trackPointer" })
  ])
], -1)
const _hoisted_11 = { class: "w-14 text-sm text-start font-bold text-darkText" }
const _hoisted_12 = { class: "text-start mb-1.5" }
const _hoisted_13 = { class: "text-sm mb-2 text-darkText font-semibold" }
const _hoisted_14 = { class: "flex justify-start border-s-2 border-dashed last:border-transparent" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center order-pointer w-5 h-5 rounded-full bg-trackPointerLight relative -start-665" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "w-2.5 h-2.5 rounded-full bg-white" })
  ])
], -1)
const _hoisted_16 = { class: "w-14 text-sm text-start font-bold text-darkText" }
const _hoisted_17 = { class: "text-start mb-1.5" }
const _hoisted_18 = { class: "text-sm mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "ms-2.5 ps-2.5 pt-4"
}
const _hoisted_21 = { class: "flex relative justify-start border-s-2 border-dashed border-transparent -ms-2.5" }
const _hoisted_22 = { class: "pe-4" }
const _hoisted_23 = { class: "w-18 text-sm font-bold" }
const _hoisted_24 = { class: "relative -top-0.5" }
const _hoisted_25 = { class: "ms-2.5 font-bold text-darkText" }
const _hoisted_26 = { class: "text-start mb-1.125" }
const _hoisted_27 = { class: "text-sm text-darkText" }
const _hoisted_28 = {
  key: 0,
  class: "text-sm mb-3"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "ms-2.5 ps-2.5 pt-4" }
const _hoisted_31 = { class: "flex justify-end" }
const _hoisted_32 = { class: "tertiary px-2 py-2 me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleCollapse())),
      class: _normalizeClass([{'pb-2': _ctx.show}, "p-665 me-2 cursor-pointer flex items-center justify-start order-details-top chevron border-black"])
    }, [
      _createElementVNode("p", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.order.originalOrder.orderId), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.order.orderStatus.value), 1)
        ]),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.order.originalOrder.createdAt), 1)
      ])
    ], 2),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('orders.from')), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.order.originalOrder.userAddress), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('orders.to')), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.order.originalOrder.darkStore.name), 1)
              ])
            ])
          ]),
          _hoisted_19,
          (_ctx.order.driver)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("p", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, [
                        _createVNode(_component_BaseIcon, { name: "truck" })
                      ]),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('orders.driver')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.createDriverFullName(_ctx.order.driver.driverInfo)), 1),
                    (_ctx.order.driver.vehicleInfo)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_28, "By " + _toDisplayString(_ctx.order.driver.vehicleInfo.vehicleType.value), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.order.driver)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_29))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", _hoisted_32, _toDisplayString(_ctx.$t('buttons.call')), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editOrder(_ctx.order))),
                class: "primary px-2 py-2"
              }, _toDisplayString(_ctx.$t('buttons.modifyOrder')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}